<template>
    <div class="marking content-view">
        <h2 class="fs-24 text-center fc-theme">旺旺强行打标</h2>
        <p class="subtitle text-center fs-14 fc-666">给指定的买家旺旺打标，强行打标后宝贝出现在手淘搜索页前20位，可实现宝贝精准推送的效果，做单、引流利器！</p>
        <top-price code="wwfscreen"></top-price>
        <div class="flex marginT-20 paddingL-50">
            <el-button type="primary" @click="activeMarking = 'search'" :plain="activeMarking != 'search'">旺旺搜索打标</el-button>
            <el-button class="marginL-20" type="primary" @click="$router.push({path: '/push/also-like'})" :plain="activeMarking != 'like'">猜你喜欢打标</el-button>
            <el-button class="marginL-20" type="primary" @click="activeMarking = 'xlsx'" :plain="activeMarking != 'xlsx'">上传表格打标</el-button>
            <el-button class="marginL-20" type="primary" @click="$router.push({path: '/weightpush'})" :plain="activeMarking != 'like'">其他入口打标</el-button>
        </div>
        <div class="flex mark-content">
            <!-- 旺旺搜索打标 -->
            <div v-show="activeMarking === 'search'" class="flex-1">
                <el-form ref="form" :model="form" label-width="100px" label-position="left">
                    <el-form-item label="账号类型：">
                        <el-radio-group v-model="form.account_type">
                            <el-radio :label="1">旺旺号</el-radio>
                            <el-radio :label="2">买家ID</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="打标方式：">
                        <el-radio-group v-model="form.markType">
                            <el-radio :label="1">批量打标</el-radio>
                            <el-radio :label="2">单个打标</el-radio>
                            <el-radio :label="'plsbq'">批量刷标签</el-radio>
                        </el-radio-group>
                        <div v-show="+form.markType === 1" class="fc-999">可批量对10个旺旺号同时打标</div>
                        <div v-show="form.markType === 'plsbq'" class="fc-999 fs-12">对一个旺旺号打上10个商品标签，猜你喜欢推荐标签词商品。</div>
                    </el-form-item>
                    <!-- 原旺旺搜索打标内容 -->
                    <div v-show="form.markType !== 'plsbq'">
                        <div class="mark-group">
                            <el-form-item :label="'打标' + accountLabel + ':'">
                                <el-input
                                    :type="form.markType == 1 ? 'textarea' : 'input'"
                                    v-model="form.account" :rows="8"
                                    :placeholder="form.markType == 1 ? '每行输入一个' + accountLabel +'，打标成功将扣点券' : '请输入' + accountLabel">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="搜索词：">
                                <el-input v-model="form.tag" placeholder="请输入淘宝搜索关键词">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="宝贝链接：">
                                <el-input v-model="form.url" placeholder="请输入宝贝链接">
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <div slot="label">
                                    <span>下单</span>
                                    <el-tooltip class="item" effect="dark" content="扫码下单直接显示打单路径下单的" placement="top-start">
                                        <i class="el-icon-question" style="margin-left: 6px;"></i>
                                    </el-tooltip>
                                </div>
                                <el-radio-group v-model="form.tag_type" @change="tagTypeChange">
                                    <el-radio :label="1">需要搜索下单</el-radio>
                                    <el-radio :label="2">不需要搜索下单</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <el-form-item>
                            <span class="fc-theme">宝贝的标题必需包含打标关键词才能打标成功！</span>
                            <el-button type="danger" @click="submitClick">立即打标</el-button>
                        </el-form-item>
                    </div>
                    <!-- 猜你喜欢打标的 批量刷标签 -->
                    <div v-show="form.markType === 'plsbq'">
                        <div class="mark-group">
                            <el-form-item :label="'打标' + accountLabel + '：'">
                                <el-input
                                    v-model="form.account"
                                    :placeholder="'请输入' + accountLabel">
                                </el-input>
                            </el-form-item>
                            <div class="search-block marginB-10" v-for="(item, index) in likeSearchForm" :key="index">
                                <div v-if="form.markType === 'plsbq'" class="left-btns">
                                    <el-button type="danger" @click="keywordAdd" icon="el-icon-plus" circle></el-button>
                                    <el-button
                                        type="danger"
                                        @click="keywordDel(index)"
                                        icon="el-icon-minus"
                                        plain
                                        circle
                                    ></el-button>
                                </div>
                                <el-form-item label="打标词：">
                                    <el-input v-model="likeSearchForm[index].tag" placeholder="请输入淘宝搜索关键词">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="商品链接：">
                                    <el-input v-model="likeSearchForm[index].url" placeholder="请输入宝贝链接">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <el-form-item>
                            <span class="fc-theme">宝贝的标题必需包含打标关键词才能打标成功！</span>
                            <el-button type="danger" @click="submitClick('plsbq')">立即打标</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <!-- 猜你喜欢打标（源代码注释， 移动到了旺旺搜索打标） -->
            <div v-show="activeMarking === 'like'" class="flex-1">
                <el-form ref="form" :model="form" label-width="100px" label-position="left">
                    <el-form-item label="打标方式：">
                        <el-radio-group v-model="form.markType">
                            <el-radio :label="1">批量刷标签</el-radio>
                            <!-- <el-radio :label="2">单个刷标签</el-radio> -->
                        </el-radio-group>
                        <div v-show="form.markType == 1" class="fc-999 fs-12">对一个旺旺号打上10个商品标签，猜你喜欢推荐标签词商品。</div>
                    </el-form-item>
                    <div class="mark-group">
                        <el-form-item label="打标旺旺：">
                            <el-input
                                v-model="form.account"
                                placeholder="请输入旺旺号">
                            </el-input>
                        </el-form-item>
                        <div class="search-block marginB-10" v-for="(item, index) in likeSearchForm" :key="index">
                            <div v-if="form.markType == 1" class="left-btns">
                                <el-button type="danger" @click="keywordAdd" icon="el-icon-plus" circle></el-button>
                                <el-button
                                    type="danger"
                                    @click="keywordDel(index)"
                                    icon="el-icon-minus"
                                    plain
                                    circle
                                ></el-button>
                            </div>
                            <el-form-item label="打标词：">
                                <el-input v-model="likeSearchForm[index].tag" placeholder="请输入淘宝搜索关键词">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="商品链接：">
                                <el-input v-model="likeSearchForm[index].url" placeholder="请输入宝贝链接">
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <el-form-item>
                        <span class="fc-theme">宝贝的标题必需包含打标关键词才能打标成功！</span>
                        <el-button type="danger" @click="onSubmit">立即打标</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 上传表格打标 -->
            <div v-show="activeMarking === 'xlsx'" class="flex-1">
                <xlsx-component v-if="activeMarking === 'xlsx'" :pricePreMonth="pricePreMonth" :userData="userData" @success="submitSuccess" @submit="submitUploadClick"></xlsx-component>
            </div>
            <!-- tips -->
            <div class="flex-1 right">
                <h3 class="fs-24 marginB-10">{{activeMarking == 'search' ? '旺旺搜索打标' : activeMarking == 'like' ? '打出猜你喜欢' : '上传表格打标'}}</h3>
                <el-card v-show="activeMarking == 'search'" class="box-card">
                    <div slot="header" class="clearfix">
                        <el-tabs v-model="activeTip">
                            <el-tab-pane label="打标须知" name="first"></el-tab-pane>
                            <el-tab-pane label="打标攻略1" name="second"></el-tab-pane>
                            <el-tab-pane label="打标攻略2" name="third"></el-tab-pane>
                            <el-tab-pane label="打标攻略3" name="fourth"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="fs-14" v-if="activeTip == 'first'">
                        <div class="title fc-theme fs-16">打标使用后的效果</div>
                        <div class="content fs-12 fc-666">
                            只需输入要打标的宝贝链接，以及要推送宝贝的目标买家旺旺账号，执行打标后，打标成功的特征：买家通过打标词搜索商品，能将打标的商品排名从后面排名提高到前20名。期间不需要买家旺旺号介入任何流程
                        </div>
                        <div class="title fc-theme fs-16">打标的使用场景</div>
                        <div class="content fs-12 fc-666">
                            1.商品核心词权重低搜索不到，但是想通过核心词搜索下单成交。
                            <br>2.目标淘宝旺旺被打标成功增加首页猜你喜欢标签注入、加大淘宝首页出现概率。
                            <br>3.精准推送给意向客户，之前有咨询没付款的，使用工具后，将宝贝推送到他们的搜索页。
                            <br>4.对于复购率很高的消耗品，列出老客户或者精准客户旺旺清单，然后批量推送，快速引爆流量。
                        </div>
                        <div class="title fc-theme fs-16">打标常见问题</div>
                        <div class="content fs-12 fc-666">
                            1.宝贝需要有一定的销量，比如一般10个以上，如果销量过低，打标效果则无，打标成功率很低。
                            <br />2.如果通过打标词在前10位商品未找到，可以在前20位商品寻找，如果仍然未找到请手淘看一下推荐的搜索词是否包含打标词。
                            <br />3.有时被打标的宝贝位置可能在20页开外,可以往下多翻几页，或者改长点的词，该商品在该打标词权重太低。
                            <br />4.并非所有类目的宝贝可成功进行打标，有店铺评分过低、成人等用品、或者降权的情况下可能无法成功打标即使打标成功也无打标的效果。
                            <br />5.打标成功的有效时长根据淘宝更新时间，打标不是都会有足迹的，打标是将搜索词和商品推荐给目标用户。
                            <br />6.打标前可以用自己的号测试看下效果，再进行批量打标，如果效果不满意可以试试关键词卡首屏功能。
                            <br />7.同一个淘宝号每日被打标次数超过一定的限度，会降低<span style="color: #f00;">打标后</span>的效果甚至<span style="color: #f00;">无效果</span>，建议旺旺号不要在<span style="color: #f00;">一天</span>超过<span style="color: #f00;">3次</span>打标，<span style="color: #f00;">黑号</span>等被淘宝关进小黑屋的账号<span style="color: #f00;">打标无效</span>。<span style="color: #f00;">使用前一定要测试</span>。

                            <!-- 1.宝贝需要有一定的销量，比如一般10个以上，如果销量过低，打标效果则无，打标成功率很低。
                            <br>2.如果通过打标词在前10位商品未找到，可以在前20位商品寻找，如果仍然未找到请打开手淘足迹确定是否出现打标商品，如果未出现请联系客服。
                            <br>3.有时被打标的宝贝位置可能在20页开外,可以往下多翻几页，或者改长点的词，该商品在该打标词权重太低。
                            <br>4.并非所有类目的宝贝可成功进行打标，有店铺评分过低、成人等用品、或者降权的情况下可能无法成功打标即使打标成功也无打标的效果。
                            <br>5.打标成功的有效时长根据淘宝更新时间，打标前可以用自己的号测试看下效果，再进行批量打标。
                            <br>6.同一个淘宝号当日被打标次数超过一定的限度，会降低打标后的效果，建议旺旺号不宜在一天超过10次打标。 -->
                        </div>
                    </div>
                    <div class="fs-14" v-if="activeTip == 'second'">
                        <div class="title fc-theme fs-16">商家的问题：</div>
                        <div class="content fs-12 fc-666">核心词下的商品权重低，商家希望买家通过核心词搜索下单，进而提高商品在核心词的权重。</div>
                        <div class="title fc-theme fs-16">解决方案：</div>
                        <div class="content fs-12 fc-666">商家使用{{isToolMainSite() ? 'V兔' : '电商'}}的旺旺强行打标，将商品的排名在指定搜索词提高到前10，买家再搜索后下单购买（打标过商品会在指定的淘宝号下搜索排名在前10），生意参谋数据显示是核心词搜索下单的。能快速的提高商品在核心词的权重值。</div>
                    </div>
                    <div class="fs-14" v-if="activeTip == 'third'">
                        <div class="title fc-theme fs-16">商家的问题：</div>
                        <div class="content fs-12 fc-666">商家希望买家的淘宝号有自己商品的标签，有标签后下单购买权重提升更高。如何将买家淘宝号的标签打上指定的商品标签呢？</div>
                        <div class="title fc-theme fs-16">解决方案：</div>
                        <div class="content fs-12 fc-666">商家使用{{isToolMainSite() ? 'V兔' : '电商'}}的旺旺强行打标，将商品标签第一次打标到用户淘宝号上，用户通过打标词进行浏览商品（为了能快速打上商品的标签，同时做货比三家，同店浏览，咨询客服）完成一次操作，选择店铺里同类商品这样操作进行3到4次，该买家有90%会出现该商品的标签</div>
                    </div>
                    <div class="fs-14" v-if="activeTip == 'fourth'">
                        <div class="title fc-theme fs-16">商家的问题：</div>
                        <div class="content fs-12 fc-666">商家希望买家能通过手淘首页的猜你喜欢找到商品下单。</div>
                        <div class="title fc-theme fs-16">解决方案：</div>
                        <div class="content fs-12 fc-666">第一步：结合打标攻略2将商品的标签出现在淘宝标签里，搜索找到目标商品，进行浏览，收藏关注，和客服咨询商品的常规信息。
                            <br>第二步：寻找同类的其他商品大概浏览三到四个，随便收藏几个竞品，后期可以取消收藏
                            <br>第三步：重复上述第一、二步，一天操作两到三次。重复3天，重复浏览的商品大概率会在猜你喜欢中出现。</div>
                    </div>
                </el-card>
                <el-card v-show="activeMarking == 'like'" class="box-card">
                    <div slot="header" class="clearfix">
                        <el-tabs v-model="activeTip">
                            <el-tab-pane label="功能须知" name="first"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="fs-14" v-if="activeTip == 'first'">
                        <div class="title fc-theme fs-16">猜你喜欢打标后效果</div>
                        <div class="content fs-12 fc-666">
                            使得该旺旺号手淘首页出现打标商品或者同类目商品。<br>
                            对一个旺旺号进行猜你喜欢打标，打上同类目的商品10次。旺旺再次打开
                            手淘在手淘首页的猜你喜欢、直播推荐、搜索推荐词都会推荐打标词或者
                            关联词。
                        </div>
                        <div class="title fc-theme fs-16">猜你喜欢打标使用场景</div>
                        <div class="content fs-12 fc-666">
                            1、下单淘宝号标签不精准，没有需要的商品标签，通过猜你喜欢打标能
                            有效快速的使得淘宝推荐系统推出打标的商品标签。<br>
                            2、辅助做单流程，快速通过搜索短词找到商品。打标成功后无需卡任何
                            条件即可将打标的商品推荐到搜索结果的前20位。
                        </div>
                        <div class="title fc-theme fs-16">刷出猜你喜欢</div>
                        <div class="content fs-12 fc-666">
                            1、打标工具只能使得官方系统认为该旺旺号对你打标的商品，打标的搜
                            索词有购买欲望，官方系统会在首页推荐这类商品。<br>
                            2、使用该功能能快速将该商品打上指定的标签，再结合用户收藏关注等
                            操作能实现出来指定的商品在猜你喜欢中出现指定商品
                        </div>
                    </div>
                </el-card>
                <el-card v-show="activeMarking == 'xlsx'" class="box-card">
                    <div slot="header" class="clearfix">
                        <el-tabs v-model="activeTip">
                            <el-tab-pane label="功能须知" name="first"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="fs-14" v-if="activeTip == 'first'">
                        <div class="title fc-theme fs-16">风险提示</div>
                        <div class="content fs-12 fc-666">
                            1、批量导入表格系统有可能无法识别导入数据导致打标失败，请务必严格按照按照模板进行导入。<br>
                            2、导入表格确认账户点券足够打标数量，否则无法进行打标。<br>
                            3、开始打标，系统会按照处理任务列表进行打标，无法中途暂停
                            或者停顿，请打标前务必确认数据。
                        </div>
                        <div class="title fc-theme fs-16">打标规则</div>
                        <div class="content fs-12 fc-666">
                            1、打标失败不扣取点券。<br>
                            2、导入数据最多支持200个打标数据量同时进行，建议同一个店铺一次性打标数不超过100个。请自行做好数据处理。
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
        <!-- 打标查询记录 -->
        <div class="query-record">
            <el-card class="box-card flex-1 marginT-20">
                <div slot="header" class="flex flex-between">
                    <span class="fw-bold fc-333">打标查询记录 <span style="font-size: 12px; color: #f00; padding-left: 6px;">(查询记录数据仅保存90天)</span></span>
                    <!-- <span class="fc-theme fs-14">1分钟后自动刷新更新</span> -->
                </div>
                <div>
                    <div class="table">
                        <el-table :data="tableData" fit
                                  :span-method="arraySpanMethod"
                                  style="border: 1px solid #eee;">
                            <el-table-column prop="invoke_params.account"
                                             label="打标旺旺" align="center">
                                <template slot-scope="scope">
                                    <div>
                                        <p v-if="scope.row.invoke_params.account">{{scope.row.invoke_params.account}}</p>
                                        <div v-if="scope.row.invoke_params.items && scope.row.invoke_params.items.length > 0"
                                             @click="recordDialog.table = scope.row.invoke_params.items, recordDialog.show = true"
                                             class="fc-blue point"
                                        >显示详细</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column width="300" label="宝贝链接(宝贝ID)">
                                <template slot-scope="scope">
                                    <el-popover trigger="hover" placement="top">
                                        <p>{{ scope.row.invoke_params.url }}</p>
                                        <div slot="reference"
                                             class="name-wrapper">
                                            {{ scope.row.invoke_params.url }}
                                        </div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="invoke_params.tag"
                                             align="center" label="打标关键词"></el-table-column>
                            <el-table-column prop="created_at" label="提交时间">
                                <template
                                    slot-scope="scope">{{ (scope.row.invoke_time * 1000) | dateFormatUtils}}</template>
                            </el-table-column>
                            <el-table-column prop="search_account" label="完成时间">
                                <template
                                    slot-scope="scope">{{ (scope.row.invoke_time * 1000) | dateFormatUtils}}</template>
                            </el-table-column>
                            <el-table-column prop="status" align="center"
                                             width="100" label="打标状态">
                                <template slot-scope="scope">{{ scope.row.result_code == 0 ? '成功' : '失败'}}</template>
                            </el-table-column>
                            <el-table-column prop="code" align="center" label="备注">
                                <template slot-scope="scope">
                                    <el-popover trigger="hover" placement="top">
                                        <p>{{ scope.row.result_message || '--'}}
                                        </p>
                                        <div slot="reference"
                                             class="name-wrapper">
                                            {{ scope.row.result_message || '--'}}
                                        </div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" width="100" prop="money_type" label="消耗点券">
                                <template slot-scope="scope">{{scope.row.invoke_paid_point}}</template>
                            </el-table-column>
                            <el-table-column align="center" width="100" label="二维码">
                                <template slot-scope="scope">
                                    <img @click="tableQrCodeShow(scope.row)" style="cursor: pointer" width="30" height="30" :src="require('@/index/assets/img/qrcode_icon.png')" alt="">
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pages marginT-20 text-center">
                        <el-pagination @current-change="handleCurrentChange"
                                       :current-page="page" :page-size="5"
                                       layout="total, prev, pager, next, jumper"
                                       :total="total"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
        <mark-record-details v-if="recordDialog.show" v-model="recordDialog.show" :table="recordDialog.table"></mark-record-details>
    </div>
</template>

<script>
import mixin from '../mixin/pagination'
import appConfig from '../mixin/appConfig'
import { mapState } from 'vuex'
import xlsxComponent from './marking/xlsx'
import markRecordDetails from '../components/_dialog/markRecordDetails'

const initLikeList = [
    {
        tag: '',
        url: ''
    },
    {
        tag: '',
        url: ''
    },
    {
        tag: '',
        url: ''
    }
]
export default {
    mixins: [mixin, appConfig],
    computed: {
        ...mapState(['userData', 'phone']),
        accountLabel (){
            return this.form.account_type == 1 ? '旺旺号' : '买家ID';
        },
        taskType (){
            return this.form.account_type == 1 ? 1 : 999;
        },
    },
    components: {
        xlsxComponent,
        markRecordDetails
    },
    data() {
        return {
            activeMarking: 'search',
            activeTip: 'first',
            pricePreMonth: {},
            form: {
                account_type: 1,    // 1. 打标旺旺； 2. 用户 UID
                markType: 2,
                account: '',
                tag: '',
                url: '',
                tag_type:  2, // 1需要搜索下单 2不需要搜索下单
            },
            likeSearchForm: initLikeList,
            searchForm: {
                cate: 'tool',
                method: 'wwfscreen',
                psize: 5,
                'access-token': localStorage.token
            },
            tableData: [],
            recordDialog: {
                show: false,
                table: []
            },
            tableUrl: '/tool/accounts/api-record'
        }
    },
    methods: {
        // todo: 检查商品 URL 是否合法
        checkItemURL () {

        },
        tagTypeChange(value) {
            if (!this.userData.is_vip && value === 1) {
                this.form.tag_type = 2;
                this.$message.warning("该选项仅对会员用户使用, 请先开通会员")
            }
        },

        tipForce() {
            // 确定不是在预渲染环境下
            if (!localStorage.compile) {
                this.$alert('打标已经恢复', '重要通知', {
                    confirmButtonText: '确定',
                    showClose: false,
                    callback: action => {
                        // this.$router.push('/checkNum/firstPause')
                    }
                })
            }
        },
        async singleSubmit(form) {
            try {
                const data = await this.$fetch('/api/proxy/web/wwfscreen', { ...form }, 'post')
                return Promise.resolve(data)
            } catch (e) {
                return Promise.reject(e)
            }
        },

        // 单个打标或批量打标或批量刷标签
        async submitClick(type = undefined) {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }

            window.checkDiscountPackage("wwfscreen")

            let paramsArr = []; // 参数列表
            let taskType = this.taskType;

            // 批量刷标签
            if (type === "plsbq") {
                let arr = []
                this.likeSearchForm.forEach(item => {
                    if (item.tag && item.url) {
                        arr.push(item)
                    }
                })
                if (!this.form.account) {
                    this.$message.error('请填写旺旺号')
                    return
                }
                if (arr.length === 0) {
                    this.$message.error('至少需要一组打标词与链接')
                    return
                }
                arr.forEach(item => {
                    let uploadData = {
                        account: taskType == 1 ? this.form.account : ('||' + this.form.account),
                        task_type: taskType,
                        tag: item.tag,
                        url: item.url,
                    }
                    paramsArr.push(uploadData)
                })

            } else {
                // 单个打标或批量打标
                // 表单校验
                let validation = true
                Object.values(this.form).map(key => {
                    if (!key) {
                        this.$message.error('请填写完整')
                        validation = false
                    }
                })
                if (!validation) return

                // 因为猜你喜欢移动到了其它地方, 所以 submit 触发后不是批量刷标签 就是 批量打标和单个打标
                let wwList = this.form.account.split(/\r?\n/)
                if (wwList.length > 1) {
                    // 批量打标
                    wwList.forEach((item, index) => {
                        let uploadData = {
                            account: taskType == 1 ? item : ('||' + item),
                            task_type: taskType,
                            tag: this.form.tag,
                            url: this.form.url,
                            tag_type: this.form.tag_type,
                        }

                        if (uploadData.account && uploadData.tag && uploadData.url) {
                            uploadData.account = uploadData.account.replace(/ /g, '')
                            uploadData.tag = uploadData.tag.replace(/ /g, '')
                        } else {
                            return
                        }

                        paramsArr.push(uploadData)
                    })

                } else {
                    // 单个打标
                    let uploadData = {
                        account: taskType == 1 ? wwList[0] : "||" + wwList[0],
                        task_type: taskType,
                        tag: this.form.tag,
                        url: this.form.url,
                        tag_type: this.form.tag_type,
                    }

                    paramsArr.push({ ...uploadData })
                }
            }
            await this.submitStart(paramsArr)
        },

        // 上传表格打标
        async submitUploadClick(paramsArr) {
            await this.submitStart(paramsArr)
        },

        async submitStart(paramsArr) {
            let loading = this.$loading({
                lock: true,
                text: '提交中',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.5)'
            })
            try {
                let resArr = await this.requestLoop(paramsArr);
                if (!resArr.length) {
                    console.log("出错了: ", resArr)
                }
                if (+resArr[0].code === 0) {
                    // 如果不需要搜索下单, 则进行返回数据处理
                    if (+this.form.tag_type !== 1) {
                        this.$message.success('已提交')
                    } else {
                        // 如果需要搜索下单, 则先进行二维码弹框 然后正常处理打单请求
                        // 逻辑改变, 先进性打单, 成功后在进行弹框处理
                        if (+this.form.tag_type === 1) {
                            let infoObj = {
                                tag: this.form.tag,
                                url: this.form.url,
                                invoke_time: resArr[0].time,
                            }
                            if (resArr.length > 1) {
                                infoObj.invoke_method = "wwfscreen";
                            }
                            window.showPushQrCode(infoObj, "打标成功")
                        }
                    }
                    setTimeout(() => {
                        this.getUserInfo().then(res => {})
                        this.init().then(res => {})
                    }, 100)
                }
            } finally {
                loading.close()
            }
        },

        // 传入参数数组, 如果数组内参数对象超过 1 个, 则循环请求
        async requestLoop(paramsArr) {
            if (!paramsArr || !paramsArr.length) {
                this.$message.warning("请输入正确的参数")
                return Promise.reject("请输入正确的参数")
            }

            if (paramsArr.length === 1) {
                let res = await this.requestStart(paramsArr[0])
                return Promise.resolve([res])
            }

            // 余额核对
            const res = await this.$fetch('/api/proxy/web/wwfscreen/precheck', { list: paramsArr }, 'post')
            let shouldSubmit = true;

            if (res.data.res == 'error') {
                let errMsg = res.data.msg ? res.data.msg : '打标余额可能不足';
                try {
                    await this.$confirm(errMsg, '余额不足提示', {
                        confirmButtonText: '继续',
                        cancelButtonText: '返回',
                        type: 'warning',
                    });
                    // 用户点击了"继续"，shouldSubmit 保持 true
                } catch {
                    // 用户点击了"返回"或关闭对话框
                    shouldSubmit = false;
                }
            }

            if (!shouldSubmit) {
                return false;
            }
            
            let resArr = [];
            for (let i=0; i<paramsArr.length; i++) {
                try {
                    let res = await this.requestStart(paramsArr[i])
                    resArr.push(res)
                } catch (e) {
                    // catch 不错处理, 请求方法内自有处理
                }
            }

            return resArr;
        },

        // 传入参数, 正式请求并返回结果
        async requestStart(params) {
            const res = await this.$fetch('/api/proxy/web/wwfscreen', { ...params }, 'post')
            return Promise.resolve(res)
        },

        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.invoke_params.items && row.invoke_params.items.length > 0) {
                if (columnIndex === 0) {
                    return [1, 3]
                } else if (columnIndex === 2 || columnIndex === 1) {
                    return [0, 0]
                }
            }
        },
        async priceLimit() {
            const data = await this.$fetch('/api/proxy/web/tool/detail', {name: 'wwfscreen'})
            this.pricePreMonth = data.data
        },
        async getUserInfo() {
            const data = await this.$fetch('/tool/members/info', {
                'access-token': localStorage.token
            })
            this.$store.dispatch('setUserData', data.data)
        },
        keywordAdd() {
            if (this.likeSearchForm.length > 15) {
                this.$message.error('一次最多添加15组')
                return
            }
            this.likeSearchForm.push({
                tag: '',
                url: ''
            })
        },
        keywordDel(index) {
            if (this.likeSearchForm.length === 1) {
                this.$message.error('至少为一个')
                return
            }
            this.likeSearchForm.splice(index, 1)
        },

        // 批量刷标签
        async searchLike() {
            let arr = []
            this.likeSearchForm.forEach(item => {
                if (item.tag && item.url) {
                    arr.push(item)
                }
            })
            if (!this.form.account) {
                this.$message.error('请填写旺旺号')
                return
            }
            if (arr.length == 0) {
                this.$message.error('至少需要一组打标词与链接')
                return
            }
            if (arr.length > 2) {
                this.batchSubmit(arr, 'like')
                return
            }
            let loading = this.$loading({
                lock: true,
                text: '提交中',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.5)'
            })
            await Promise.all(
                arr.map(async (item, index) => {
                    await this.singleSubmit({
                        account: this.form.account,
                        tag: item.tag,
                        url: item.url
                    })
                })
            )
            loading.close()
            this.$message.success('已提交')
            this.getUserInfo()
            this.init()
        },
        submitSuccess() {
            this.getUserInfo()
            this.init()
        },

        // 批量打标
        async batchSubmit(list, type) {
            let loading = this.$loading({
                lock: true,
                text: '提交中',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.5)'
            })
            let subData = []
            for (let i = 0; i < list.length; i++) {
                if (i == 800) {
                    break
                }
                const sheetData = {
                    task_sn: i,
                    account: type == 'like' ? this.form.account : list[i],
                    tag: type == 'like' ? list[i].tag :this.form.tag,
                    url: type == 'like' ? list[i].url :this.form.url,
                    // url:type == 'like' ? this.getQueryVariable(new URL(list[i].url), 'id')  : this.getQueryVariable(new URL(this.form.url), 'id')
                }
                if (sheetData.account && sheetData.tag && sheetData.url) {
                    sheetData.account = sheetData.account.replace(/ /g, '')
                    sheetData.tag = sheetData.tag.replace(/ /g, '')
                    if (!sheetData.account || !sheetData.tag) {
                        continue
                    }
                } else {
                    continue
                }
                subData.push(sheetData)
            }

            const { code, data } = await this.$fetch(
                '/api/proxy/web/wwfscreen',
                {
                    items: JSON.stringify(subData),
                    tag_type: +this.form.markType === 1 ? this.form.tag_type : undefined
                },
                'post'
            )
            loading.close()
            if (code == 0) {
                if (+this.form.markType === 1 && +this.form.tag_type === 1) {
                    // some code ...
                    // 如果需要搜索下单, 则先进行二维码弹框 然后正常处理打单请求
                    // 逻辑改变, 先进行打单, 然后打单成功弹出二维码
                    if (+this.form.tag_type === 1) {
                        window.showPushQrCode({
                            tag: this.form.tag,
                            url: this.form.url,
                        }, "打标成功")
                    }
                } else {
                    this.$message.success('提交成功')
                }
                this.getUserInfo()
                this.init()
                setTimeout(() => {
                    this.$store.dispatch('upDateUser')
                    this.init()
                }, 5000)
            }
        },
        async onSubmit() {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }
            // if (this.activeMarking == 'like') {
            if (this.form.markType === 'plsbq') {
                this.searchLike()
                return
            }

            // 表单校验
            let validation = true
            Object.values(this.form).map(key => {
                if (!key) {
                    this.$message.error('请填写完整')
                    validation = false
                }
            })

            if (!validation) return

            // 因为猜你喜欢移动到了其它地方, 所以 submit 触发后不是批量刷标签 就是 批量打标和单个打标
            const textList = this.form.account.split('\n')
            // if (textList.length > 2) {
            if (textList.length > 1) {
                // 前往批量打标
                this.batchSubmit(textList)
                return
            }
            // 开始单个打标
            try {
                let uploadData = {
                    account: textList[0],
                    tag: this.form.tag,
                    url: this.form.url,
                    tag_type: this.form.tag_type,
                }

                let res = await this.singleSubmit({ ...uploadData });
                if (+res.code === 0) {
                    // 如果不需要搜索下单, 则进行返回数据处理
                    if (+this.form.tag_type !== 1) {
                        this.$message.success('已提交')
                    } else {
                        // 如果需要搜索下单, 则先进行二维码弹框 然后正常处理打单请求
                        // 逻辑改变, 先进性打单, 成功后在进行弹框处理
                        if (+this.form.tag_type === 1) {
                            window.showPushQrCode({ ...uploadData}, "打标成功")
                        }
                    }
                    this.getUserInfo()
                    this.init()
                } else {
                    this.$message.error(res.msg)
                }

            } catch (e) {
                this.$message.error(e.msg)
            }
        },

        tableQrCodeShow(row) {
            this.$message.warning("二维码不存在或已失效")
            // window.showQrCode(row.code_url)
        },
    },
    async mounted() {
        if (localStorage.token) {
            this.init()
            await this.getUserInfo()
            this.priceLimit()
        }
    },
    watch: {
        'form.markType'(newValue, oldValue) {
            this.form.account = ''
            if (this.activeMarking == 'like' && newValue == 2) {
                this.likeSearchForm = [{
                    tag: '',
                    url: ''
                }]
            } else if (this.activeMarking == 'like' && newValue == 1) {
                this.likeSearchForm = initLikeList
            }
        },
        phone(newValue) {
            if (newValue) {
                this.priceLimit()
            }
        },
        activeMarking(newValue, oldValue) {
            this.form.markType = 1
            this.likeSearchForm = initLikeList
            this.activeTip = 'first'
        },
    }
}
</script>

<style lang="scss" scoped>
.marking {
    .top-tip {
        padding: 20px 0 6px;
        border-bottom: 1px solid #ddd;
        i {
            color: #ff5920;
        }
    }
    .mark-content {
        padding: 20px;
    }
    .right {
        margin-left: 30px;
        .title {
            margin-top: 5px;
        }
    }
    .name-wrapper {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .el-button--primary.is-plain:hover {
        background: #ecf5ff;
        border-color: #409EFF;
        color: #409EFF;
    }
    .search-block {
        position: relative;
        border: 1px solid #f13d6390;
        padding: 10px 20px 0 20px;
        border-radius: 4px;
        background: #f13d6412;
        .left-btns {
            position: absolute;
            left: -48px;
            display: flex;
            flex-direction: column;
            // width: 40px;
            .el-button + .el-button {
                margin-left: 0;
                margin-top: 10px;
            }
        }
    }
}
</style>
<style lang="scss">
.marking {
    .el-card__header {
        padding-bottom: 0;
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .el-tabs__nav-wrap::after {
        height: 0;
    }
    .el-card__body {
        min-height: 433px;
    }
}
</style>
